import { AtendimentoType } from '../../../../../../_metronic/helpers'
import { createListFilters, IOption } from '../../../../../components'

export type MonitoramentoFilters = {
  paciente: string
  protocolo: string
  estado?: IOption<number>
  empresa?: IOption<number>
  /** Depende da instituição (é limpa quando a instituição sai). */
  unidade?: IOption<number>
  tipoAtendimento?: IOption<AtendimentoType>
  especialidade?: IOption<number>
  profissional?: IOption<number>
  /** Datas puras (aaaa-mm-dd) do <input type="date">. */
  solicitacao: string
  inicio: string
}

export const { ListFiltersProvider, useListFilters } = createListFilters<MonitoramentoFilters>({
  paciente: '',
  protocolo: '',
  estado: undefined,
  empresa: undefined,
  unidade: undefined,
  tipoAtendimento: undefined,
  especialidade: undefined,
  profissional: undefined,
  solicitacao: '',
  inicio: '',
})
